module.exports = __webpack_public_path__ + "img/DE00954.2c21f1ea.png";